import React from 'react';
import { t } from '@lingui/macro';
import { createStackNavigator } from '@react-navigation/stack';

import LogoTitle from '@src/components/LogoTitle';
import useStackScreenOptions from '@src/hooks/useStackScreenOptions';
import { i18n } from '@src/i18n';
import AuthenticationScreen from '@src/screens/Authentication';
import ForgetPasswordScreen from '@src/screens/ForgetPassword';
import ResetPasswordScreen from '@src/screens/ResetPassword';
import ResetPasswordOTPScreen from '@src/screens/ResetPasswordOTP';
import SignInScreen from '@src/screens/SignIn';
import SignUpOTPScreen from '@src/screens/SignUpOTP';
import SignUpPhoneScreen from '@src/screens/SignUpPhone';

import { UnauthenticatedRootStackParamList } from './types';

const Stack = createStackNavigator<UnauthenticatedRootStackParamList>();

const Component: React.FC = () => {
  const stackScreenOptions = useStackScreenOptions();
  return (
    <Stack.Navigator headerMode="screen" screenOptions={stackScreenOptions}>
      <Stack.Screen
        name="Authentication"
        component={AuthenticationScreen}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name="SignUpPhone"
        component={SignUpPhoneScreen}
        options={{
          headerShown: true,
          title: `${i18n._(t`Sign up`)} - ${i18n._(t`Youtopin`)}`,
        }}
      />
      <Stack.Screen name="SignUpOTP" component={SignUpOTPScreen} />
      <Stack.Screen
        name="SignIn"
        component={SignInScreen}
        options={{
          title: `${i18n._(t`Sign in`)} - ${i18n._(t`Youtopin`)}`,
          headerTitle: () => <LogoTitle />,
          headerTitleAlign: 'center',
        }}
      />
      <Stack.Screen
        name="ForgetPassword"
        component={ForgetPasswordScreen}
        options={{
          title: `${i18n._(t`Forget password`)} - ${i18n._(t`Youtopin`)}`,
          headerTitle: () => <LogoTitle />,
          headerTitleAlign: 'center',
        }}
      />
      <Stack.Screen
        name="ResetPasswordOTP"
        component={ResetPasswordOTPScreen}
        options={{
          title: `${i18n._(t`Reset Password OTP`)} - ${i18n._(t`Youtopin`)}`,
          headerTitle: () => <LogoTitle />,
          headerTitleAlign: 'center',
        }}
      />
      <Stack.Screen
        name="ResetPassword"
        component={ResetPasswordScreen}
        options={{
          title: `${i18n._(t`Reset Password`)} - ${i18n._(t`Youtopin`)}`,
          headerTitle: () => <LogoTitle />,
          headerTitleAlign: 'center',
        }}
      />
    </Stack.Navigator>
  );
};

Component.displayName = 'UnauthenticatedRootStack';

export default Component;
